<template>
    <div class="bg-gray grid-content div-footer">
        <el-row>
            <p>监督机构:  <a href="http://www.nmpa.gov.cn">国家药品监督管理局</a>&nbsp;<a href="http://mpa.jiangxi.gov.cn/">江西省药品监督管理局</a>&nbsp;<a href="http://sjj.yichun.gov.cn/">宜春市市场监督管理局</a></p>
        </el-row>
        <el-row>
            <a href="http://beian.miit.gov.cn">备案号&#65306;赣ICP备2022007306号</a>&nbsp;
            <a href="/#/License">药品经营许可证号&#65306;赣AA795000471</a>&nbsp;
            <a href="/#/Record">互联网药品信息服务备案凭证号&#65306;(赣)-非经营性-2022-0170</a>
        </el-row>
        <el-row>
            <p>版权所有 &nbsp;©江西聚美医药连锁有限公司</p>
        </el-row>
    </div>
</template>
<script>
export default {
    name : 'Footer'
}
</script>
<style>
    .div-footer{
        background-color:  rgba(255, 255, 255, 0.9);
        padding:8px;
    }
    .topLogoImage{
        width: 100%;
    }
    .topLink{
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue